/**
 * @generated SignedSource<<f4c126ffefcaaf9639b2c78bd4514fb1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singlePersonKnowledgeCardRelay_reportingLines$data = {
  readonly reportingLines: {
    readonly __typename: "KnowledgeDiscoveryReportingLines";
    readonly managers: ReadonlyArray<{
      readonly accountIdentifier: string | null | undefined;
      readonly numberOfDirectReports: number | null | undefined;
      readonly numberOfTotalReports: number | null | undefined;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
        readonly picture: string | null | undefined;
      } | null | undefined;
    }>;
    readonly peers: ReadonlyArray<{
      readonly accountIdentifier: string | null | undefined;
      readonly numberOfDirectReports: number | null | undefined;
      readonly numberOfTotalReports: number | null | undefined;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
        readonly picture: string | null | undefined;
      } | null | undefined;
    }>;
    readonly reports: ReadonlyArray<{
      readonly accountIdentifier: string | null | undefined;
      readonly numberOfDirectReports: number | null | undefined;
      readonly numberOfTotalReports: number | null | undefined;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
        readonly picture: string | null | undefined;
      } | null | undefined;
    }>;
    readonly user: {
      readonly accountIdentifier: string | null | undefined;
      readonly numberOfDirectReports: number | null | undefined;
      readonly numberOfTotalReports: number | null | undefined;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
        readonly picture: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "singlePersonKnowledgeCardRelay_reportingLines";
};
export type singlePersonKnowledgeCardRelay_reportingLines$key = {
  readonly " $data"?: singlePersonKnowledgeCardRelay_reportingLines$data;
  readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_reportingLines">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "picture"
      },
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aaid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "siteId"
    }
  ],
  "kind": "Fragment",
  "name": "singlePersonKnowledgeCardRelay_reportingLines",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "aaid",
          "variableName": "aaid"
        },
        {
          "kind": "Variable",
          "name": "orgId",
          "variableName": "orgId"
        },
        {
          "kind": "Variable",
          "name": "siteId",
          "variableName": "siteId"
        }
      ],
      "kind": "LinkedField",
      "name": "reportingLines",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "managers",
              "plural": true,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "reports",
              "plural": true,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "peers",
              "plural": true,
              "selections": (v0/*: any*/)
            }
          ],
          "type": "KnowledgeDiscoveryReportingLines"
        }
      ]
    }
  ],
  "type": "KnowledgeDiscoveryQueryApi"
};
})();

(node as any).hash = "39f148778c4afeaf5cb148a80dda3216";

export default node;
